// @flow
import { useEffect } from 'react';
import { useNavigate, useMatch, useResolvedPath } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { authDataState, appConfigState, userDataState } from './store';
import AppRoutes from './routes';

function App(): React$Node {
	const [appConfig] = useRecoilState(appConfigState);

	const { i18n } = useTranslation();

	useEffect(() => {
		const htmlElement = document.querySelector('html');
		if (htmlElement) {
			htmlElement.setAttribute('dir', i18n.dir(appConfig.lang));
			htmlElement.setAttribute('lang', appConfig.lang);
		}
	}, [appConfig.lang, i18n]);

	const navigate = useNavigate();
	const [authData] = useRecoilState(authDataState);
	const [userData] = useRecoilState(userDataState);
	const adminMatchResolved = useResolvedPath('admin/*');
	const adminMatch = useMatch({
		path: adminMatchResolved.pathname,
		end: true,
	});
	const superAdminMatchResolved = useResolvedPath('superAdmin/*');
	const superAdminMatch = useMatch({
		path: superAdminMatchResolved.pathname,
		end: true,
	});
	const customerMatchResolved = useResolvedPath('customer/*');
	const customerMatch = useMatch({
		path: customerMatchResolved.pathname,
		end: true,
	});
	const providerMatchResolved = useResolvedPath('provider/*');
	const providerMatch = useMatch({
		path: providerMatchResolved.pathname,
		end: true,
	});

	useEffect(() => {
		if (
			!authData.token &&
            (adminMatch || superAdminMatch || customerMatch || providerMatch)
		) {
			navigate('/auth/login');
		}
	}, [
		authData,
		userData,
		navigate,
		adminMatch,
		superAdminMatch,
		customerMatch,
		providerMatch,
	]);

	return <AppRoutes />;
}

export default App;
